import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAppConfig } from '../config/firebase';

const DEFAULT_CONFIG = {
  pricing: {
    proMonthlyPrice: 5,
    proCurrency: 'usd',
    trialPeriodDays: 7,
  },
  freeTier: {
    maxSavedQRCodes: 10,
    allowedDownloadFormats: ['png'],
    allowedTemplates: ['basic', 'rounded', 'dots'],
  },
  proTier: {
    allowedDownloadFormats: ['png', 'svg', 'pdf', 'jpeg'],
    allowedTemplates: [
      'basic',
      'rounded',
      'dots',
      'modern',
      'gradient',
      'minimal',
    ],
  },
  redirects: {
    baseDomain: 'qraftcode.com',
    basePath: '/r/',
  },
  featureFlags: {
    dynamicQREnabled: false,
    analyticsEnabled: false,
    wifiQREnabled: false,
  },
};

const AppConfigContext = createContext({
  config: DEFAULT_CONFIG,
  loading: true,
});

export const AppConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAppConfig()
      .then((data) => {
        if (data) setConfig(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppConfigContext.Provider value={{ config, loading }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => useContext(AppConfigContext);
